import api from "./api";
import API_URLS from "../../constants/api-urls";

export default class CaskAndAgingApi {
  createCaskAndAging(payload) {
    return api.post(API_URLS.URL.caskandaging.createCaskAndAging, payload);
  }

  updateCaskAndAging(caskAndAgingId, payload) {
    return api.put(
      API_URLS.URL.caskandaging.updateCaskAndAging?.replace(
        ":id",
        caskAndAgingId,
      ),
      payload,
    );
  }

  getCaskAndAgingList(payload) {
    return api.post(API_URLS.URL.caskandaging.getCaskAndAgingList, payload);
  }

  getCaskAndAgingById(caskAndAgingId) {
    return api.get(
      API_URLS.URL.caskandaging.getCaskAndAgingById?.replace(
        ":id",
        caskAndAgingId,
      ),
    );
  }

  createSamplinglogs(payload) {
    return api.post(API_URLS.URL.caskandaging.createSamplinglogs, payload);
  }

  updateSamplinglogs(samplingLogsId, payload) {
    return api.put(
      API_URLS.URL.caskandaging.updateSamplinglogs?.replace(
        ":id",
        samplingLogsId,
      ),
      payload,
    );
  }

  getSamplinglogsList(payload) {
    return api.post(API_URLS.URL.caskandaging.getSamplinglogsList, payload);
  }

  getCaskOpenLogsList(payload) {
    return api.post(API_URLS.URL.caskandaging.getCaskOpenLogsList, payload);
  }

  createCaskOpenLogs(payload) {
    return api.post(API_URLS.URL.caskandaging.createCaskOpenLogs, payload);
  }

  updateCaskOpenLogs(caskOpenLogId, payload) {
    return api.put(
      API_URLS.URL.caskandaging.updateCaskOpenLogs?.replace(
        ":id",
        caskOpenLogId
      ),
      payload
    );
  }

  getCaskOpenLogsById(caskOpenLogId) {
    return api.get(
      API_URLS.URL.caskandaging.getCaskOpenLogsById?.replace(
        ":id",
        caskOpenLogId
      )
    );
  }

  deleteCaskOpenLogs(caskOpenLogId) {
    return api.delete(
      API_URLS.URL.caskandaging.deleteCaskOpenLogs?.replace(
        ":id",
        caskOpenLogId
      )
    );
  }
}
